import Dependencies from '../utilities/dependencies';
import InfoBox from '../includes/info-box';
import CmsApi from '../utilities/cms-api';

export default class MosaicRestaurant {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.mosaic-restaurant'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.alpine];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	#restaurant = null;

	// #infoBox;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		this.scrollToInfoBox();

		CmsApi.fetchRestaurants()
			.then(restaurants => {
				this.setRestaurant(restaurants);
				if (InfoBox.isSelected(this.#holderElement.dataset.id)) {
					this.render();
				}
			});

		this.#holderElement.addEventListener('click', (event) => {
			event.preventDefault();
			this.render();
		});
	}

	render() {
		InfoBox.currentlySelected = this.#holderElement.dataset.id;
		InfoBox.alpineData.open = true;
		InfoBox.alpineData.layout = InfoBox.RESTAURANTS_LAYOUT;
		InfoBox.alpineData.modelData = this.#restaurant;
	}

	/**
	 * @param {Array<any>} restaurants
	 */
	setRestaurant(restaurants) {
		const id = parseInt(this.#holderElement.dataset.id.split('restaurant-')[1]);
		this.#restaurant = restaurants.find(r => r.id === id);
	}

	scrollToInfoBox() {
		if (window.location.href.indexOf('?restaurant=') > -1) {
			const slug = window.location.href.split('?restaurant=')[1];
			if (this.#holderElement.dataset.slug === slug) {
				this.render();
			}
		}
	}
}
